<template>
  <b-card>
    <template v-slot:header class="px-3">
      <small class="text-muted" v-if="!noSubject" v-translate>Subject</small>
      <h6 class="mb-0" v-if="!noSubject">{{thread.subject}}</h6>
      <p class="mb-2" v-if="thread.messages">
        <small class="text-muted" v-translate="{author: thread.messages[(thread.messages.length - 1)].sender.name, createdAt: moment.utc(thread.created_at).tz($tz).format('L LT')}">
          Created by <strong>%{author}</strong> on <strong>%{createdAt}</strong>
        </small>
      </p>
      <form @submit.prevent="sendMessage">
        <b-input-group>
          <b-form-textarea
            :placeholder="$gettext('Type your message here...')"
            rows="1"
            max-rows="8"
            v-model="newMessage"
            required
          ></b-form-textarea>
          <b-button size="sm" variant="secondary" style="height: 2.5rem;display: inline" type="submit" v-translate>
            Send
          </b-button>
        </b-input-group>
        <generic-picture-upload minimal class="mt-3" ref="uploader" @updated="filesUpdated" />
      </form>
    </template>
    <ul class="chat">
      <li class="clearfix" v-for="(message, i) in thread.messages" :class="message.class">
        <span class="chat-img" :class="'float-' + message.class">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="rounded-circle" alt="img" :style="'display: inline-block; width: ' + (profilePictureSize.indexOf('px') !== -1 ? profilePictureSize : profilePictureSize + 'px') + '; height: ' + (profilePictureSize.indexOf('px') !== -1 ? profilePictureSize : profilePictureSize + 'px') + '; background: url(' + (message.sender.profile_picture || 'https://www.gravatar.com/avatar/default?s=' + profilePictureSize.replace('px', '') + '&r=pg&d=mm') + ') transparent no-repeat 50% 50%/cover;'" />
        </span>
        <div class="chat-body clearfix">
            <div class="header">
              <strong class="primary-font" :class="message.class !== 'left' ? 'float-right' : ''">{{message.sender.name}}</strong>
              <small class="text-muted" :class="message.class !== 'right' ? 'float-right' : ''">
                <font-awesome-icon :icon="['far', 'clock']" size="1x" /><span class="time" :title="moment.utc(message.created_at).tz($tz).format('L LT')">{{moment.utc(message.created_at).tz($tz).fromNow()}}</span>
              </small>
            </div>
            <div class="clearfix" v-html="$options.filters.brize(message.message)"></div>
        </div>
      </li>
    </ul>
    <small class="px-2 py-1" :class="thread.type === 'internal' ? 'bg-dark text-white' : 'bg-warning'" style="position: absolute; top: 0; right: 0">{{thread.type}}</small>
  </b-card>
</template>

<script>
import GenericPictureUpload from '@/components/GenericPictureUpload'

export default {
  name: 'ShippingMessageThreads',
  components: {
    GenericPictureUpload
  },
  props: {
    theThread: {
      type: Object,
      required: true
    },
    noSubject: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      thread: {},
      currentMssgClass: 'left',
      profilePictureSize: '50',
      newMessage: '',
      refreshTimeout: null,
      files: []
    }
  },
  created() {
    this.thread = this.theThread
    if (!this.thread.messages || this.thread.messages.length === 0) {
      this.getThread()
    } else {
      this.addClasses()
      this.setRefreshTimeout()
    }
  },
  beforeDestroy() {
    clearTimeout(this.refreshTimeout)
  },
  methods: {
    mssgClass(i) {
      if (i !== 0 && this.thread.messages[i].sender.id !== this.thread.messages[(i - 1)].sender.id) {
        this.currentMssgClass = this.currentMssgClass === 'left' ? 'right' : 'left'
      }
      return this.currentMssgClass
    },
    addClasses() {
      this.thread.messages.reverse()
      for (let i = 0; i < this.thread.messages.length; i++) {
        this.thread.messages[i].class = this.mssgClass(i)
      }
      this.thread.messages.reverse()
    },
    setRefreshTimeout() {
      this.refreshTimeout = null
      this.refreshTimeout = setTimeout(function () {
        this.getThread()
      }.bind(this), 30000)
    },
    async getThread() {
      const params = {
        includes: [
          'messages.sender'
        ]
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'shipping-threads/' + this.thread.id, {params: params})
        .then(response => {
          this.currentMssgClass = 'left'
          this.thread = response.body
          this.addClasses()
          this.setRefreshTimeout()
        })
    },
    filesUpdated(e) {
      this.files = e
    },
    sendMessage() {
      if (this.files.length > 0) {
        this.newMessage += '<hr>'
        this.newMessage += '<div class="mssg-img-wrapper">'
        for (const file of this.files) {
          this.newMessage += '<a href="' + file.response.full_path + '" target="_blank" class="mssg-img-link"><img src="' + file.response.full_path + '" class="mr-3 mb-3 mssg-img" /></a>'
        }
        this.newMessage += '</div>'
      }
      this.$http.post(this.$appConfig.api.baseUrl + 'shippings/' + this.thread.shipping_id + '/messages', {thread_id: this.thread.id, message: this.newMessage})
        .then(response => {
          this.newMessage = ''
          this.files = []
          this.$refs.uploader.files = []
          this.getThread()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.card-body
{
  overflow-y: scroll;
  height: 250px;
}
.chat {
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    margin-bottom: 10px;
    padding-bottom: 5px;
    border-bottom: 1px dotted #B3A9A9;
    &.left .chat-body {
      margin-left: 60px;
    }
    &.right .chat-body {
      margin-right: 60px;
    }
    .time {
      margin: 0 5px;
    }
  }
}
</style>
<style lang="scss">
.mssg-img {
  width: 100px;
  height: auto;
}
</style>
